import { render, staticRenderFns } from "./TvaSimpleButton.vue?vue&type=template&id=6e991fbb&scoped=true&"
import script from "./TvaSimpleButton.vue?vue&type=script&lang=js&"
export * from "./TvaSimpleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e991fbb",
  null
  
)

export default component.exports